import { css } from "@emotion/react";

export const inputCss = {
    display: "inline-block",
    width: "55px",
};

export const contentCss = css`
    margin-top: 15px;
    > * {
        margin-top: 5px;
        display: flex;
        align-items: center;
        gap: 10px;
    }
`;
